import { render, staticRenderFns } from "./order-messages.vue?vue&type=template&id=280942c0&"
import script from "./order-messages.vue?vue&type=script&lang=js&"
export * from "./order-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports